<fuse-card class="p-8 grid grid-cols-12">
  <div class="col-span-12">
    <div class="text-4xl mb-0"><b>Agencies</b></div>
    <div>View all agencies associated with this contact</div>
  </div>
  <div class="w-full col-span-12">
    <div class="flex items-center mt-4 sm:mt-0 md:mt-4">
      <!-- Search -->
      <div class="flex-auto">
        <mat-form-field class="fuse-mat-dense fuse-mat-no-subscript fuse-mat-rounded w-full">
          <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:search'"></mat-icon>
          <input matInput [(ngModel)]="searchText" [autocomplete]="'off'" [placeholder]="'Filter agencies'">
        </mat-form-field>
      </div>
    </div>

    <!--loading-->
    <div *ngIf="viewState == viewStates.loading">
      <mat-spinner class="ml-auto mr-auto "></mat-spinner>
    </div>

    <!-- no content -->
    <div *ngIf="viewState == viewStates.content && filteredAgencies().length === 0" class="mt-8 text-center">
      <app-generic-no-content title="No Agencies Found"
        subtitle="No agency associations were found for this contact. If search, please update your search criteria."
        imageUrl="https://img.icons8.com/color/256/000000/company.png" class="ml-auto mr-auto mt-5">
      </app-generic-no-content>
    </div>

    <!--content-->
    <div *ngIf="viewState == viewStates.content && filteredAgencies().length > 0">
      <div class="mt-4" *ngFor="let agency of filteredAgencies()">
        <app-agency-card [agency]="agency"></app-agency-card>
      </div>
    </div>
  </div>

</fuse-card>